import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiGithub, FiShield, FiDownload } from 'react-icons/fi';

const Hero = () => {
  return (
    <section className="pt-16 pb-20 md:pt-24 md:pb-32 px-4">
      <div className="container mx-auto max-w-6xl flex flex-col lg:flex-row items-center gap-12">
        <div className="flex-1 text-center lg:text-left">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-bold mb-6 uppercase tracking-wider">
            <SafeIcon icon={FiShield} />
            <span>Open Source & Privat</span>
          </div>
          
          <h1 className="text-4xl md:text-6xl font-extrabold tracking-tight mb-6 leading-tight">
            Browser Lock <br className="hidden md:block" />
            <span className="text-primary">Ihre Privatsphäre.</span>
          </h1>
          
          <p className="text-lg md:text-xl text-textMuted mb-10 max-w-2xl mx-auto lg:mx-0 leading-relaxed">
            Sperren Sie Ihren Browser sofort mit einem Master-Passwort. 
            Alle Daten bleiben lokal – für maximale Sicherheit Ihrer Tabs und Lesezeichen.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <a 
              href="https://chromewebstore.google.com/detail/browser-lock/jepjmljbjjplhbgcgljhikflkmlbkgpk"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-primary hover:bg-primaryHover text-white px-8 py-4 rounded-xl font-semibold transition-all shadow-lg shadow-primary/20"
            >
              <SafeIcon icon={FiDownload} className="text-xl" />
              <span>Chrome Extension</span>
            </a>
            
            <a 
              href="https://github.com/ecomcodeLab/Chrome-Passwort-Lock" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-cardBg hover:bg-borderDark text-textMain border border-borderDark px-8 py-4 rounded-xl font-semibold transition-all"
            >
              <SafeIcon icon={FiGithub} className="text-xl" />
              GitHub
            </a>
          </div>
        </div>

        <div className="flex-1 w-full max-w-xl">
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-primary to-blue-600 rounded-2xl blur opacity-10"></div>
            <div className="relative bg-bgDark border border-borderDark rounded-2xl overflow-hidden shadow-2xl">
              <div className="bg-cardBg px-4 py-2 border-b border-borderDark flex items-center justify-between">
                <div className="flex gap-1.5">
                  <div className="w-2.5 h-2.5 rounded-full bg-error/40"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-yellow-500/40"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-success/40"></div>
                </div>
              </div>
              <div className="aspect-video bg-bgDark flex items-center justify-center">
                <img 
                  src="/preview.png" 
                  alt="Browser Lock Preview" 
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentNode.innerHTML = '<div class="text-textMuted text-xs font-mono">/public/preview.png</div>';
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;